/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TurnMeUp from '../common/TurnMeUp.js';
import PlayPauseButtons from '../common/PlayPauseButtons.js';
import * as imageUtils from '../../utils/imageUtils';

const ChartItemMusic = ({item, playPause, index}) => { 
    const getThumbnail = (imageUrl, roleType) => {
        const params = '?width=30&aspectw=1&quality=80&mode=crop&scale=both&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    };
    return (
        <li>
            <div className="item-content">
                <p className="no">{index + 1}</p>
                <PlayPauseButtons trackID={item.ID} anchorClass="btn-play btn-play-dark play transition2" spanClass="circ transition" playButtonClass="icon icn-play transition" pauseButtonClass="icon icn-pause transition" /> 
                <h2>
                    <a href="#" className="transition link" onClick={(event) => playPause(event, item.ID)}>{item.Name}</a><span className="length-inline">{`(${item.LengthMins}:${(item.LengthSecs + '').padStart(2, '0')})`}</span>
                </h2>
                <p className="by">
                    <span className="artist-img">
                        <Link to={`/${item.RoleUsername}`}>
                            <img src={getThumbnail(item.ImageUrl, item.RoleType)} alt={item.RoleDisplayName} />
                        </Link>
                    </span>
                    By:
                    <br />
                    <Link to={`/${item.RoleUsername}`} className="transition link">{item.RoleDisplayName}</Link>
                </p>
            </div>

            <div className="item-turnup">
                <div className="loudtrend">
                    <p className="trend up">{item.TrendingRating}</p>
                    <span>
                        <TurnMeUp id={item.ID} rating={item.Rating} roleID={item.RoleID} isMusic />
                    </span>
                </div>
            </div>
        </li>    
    );
};

ChartItemMusic.propTypes = {
    item: PropTypes.object,
    playPause: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired
};

export default ChartItemMusic;
